import { render, staticRenderFns } from "./DetallesPacienteRegistro.vue?vue&type=template&id=04db85c8&scoped=true"
import script from "./DetallesPacienteRegistro.vue?vue&type=script&lang=js"
export * from "./DetallesPacienteRegistro.vue?vue&type=script&lang=js"
import style0 from "./DetallesPacienteRegistro.vue?vue&type=style&index=0&id=04db85c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04db85c8",
  null
  
)

export default component.exports